import React, { FC, MouseEvent, useEffect, useMemo, useRef, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { KeyboardArrowDown } from "@mui/icons-material";
import ArrowPopper from "components/app/ArrowPopper";
import { Grid } from "@mui/material";
import moment from "moment";
import { colorStyleList } from "constant";
import { classHOC } from "components/app/ClassWrapper";

const ActivityAlreadyRenderer: FC<Partial<ICellRendererParams>> = ({ data, value, node }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(null);

  const popRef = useRef<HTMLDivElement>(null);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener("click", closePop);
    return () => {
      document.removeEventListener("click", closePop);
    };
  }, []);

  const closePop = (e: Event) => {
    if (
      !popRef.current?.contains(e.target as Node) &&
      popRef.current !== e.target &&
      !rootRef.current?.contains(e.target as Node)
    ) {
      setAnchorEl(null);
    }
  };

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const dateArr = useMemo(() => {
    return [
      {
        label: "Creation Date",
        value: data?.attributes?.latestActivity?.createdDate,
      },
      {
        label: "Completion Date",
        value: data?.attributes?.latestActivity?.closedDate,
      },
    ];
  }, [data]);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          cursor: value ? "pointer" : "default",
          width: "fit-content",
        }}
        ref={rootRef}
        onClick={value ? handleClick : undefined}
      >
        {value ? (
          <span>
            Yes - <span style={{ color: colorStyleList[value]?.color }}>{value}</span>
          </span>
        ) : (
          <span style={{ color: "#B2B2B2" }}>{node?.isRowPinned() ? "" : "Not Created"}</span>
        )}
        {value ? <KeyboardArrowDown style={{ fontSize: "1rem" }} /> : null}
      </div>
      {anchorEl ? (
        <ArrowPopper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="right"
          disablePortal={false}
        >
          <div ref={popRef}>
            <Grid
              container={true}
              direction="column"
            >
              {dateArr.map((item, i) => (
                <Grid
                  item={true}
                  container={true}
                  key={item.label}
                  justifyContent="space-between"
                  style={{ marginTop: i === 0 ? 0 : 4 }}
                  alignItems="center"
                >
                  <Grid
                    item={true}
                    style={{
                      color: "#898989",
                      fontSize: 12,
                      lineHeight: "14px",
                    }}
                  >
                    {item.label}
                  </Grid>
                  <Grid
                    item={true}
                    style={{
                      color: "#333",
                      fontSize: 12,
                      lineHeight: "14px",
                      marginLeft: 16,
                      fontWeight: 500,
                    }}
                  >
                    {item.value ? moment(item.value).utc().format("MM/DD/YYYY") : "--"}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </div>
        </ArrowPopper>
      ) : null}
    </>
  );
};

export default classHOC(ActivityAlreadyRenderer);
